import React, { useEffect, useState } from "react";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import ToggleButton from "react-bootstrap/ToggleButton";
import CardIcon from "../../../images/card.png";
import Show from "../../../utils/show.component";
import { CardControlPopupMenu } from "./menu/card-control-popup-menu.component";
import { popupMenuOptions } from "../parent/data/popupMenuOptions";

export const CardControlsCard = (props) => {
  const selectCardOption = (type) => {
    props.closeAllPopupMenus();
    props.showCardControlsModal(
      true,
      type,
      props.AgreeNbr,
      props.CardType,
      props.IsActive,
      props.CardNumberLastFour
    );
  };

  const offText = () => {
    return props.IsActive ? "" : "OFF";
  };

  const onText = () => {
    return !props.IsActive ? "" : "ON";
  };

  const callUs = () => {
    if (!props.CanEdit) {
      return (
        <div className="row call-us">Unable to manage card online. Call us at 888-267-7200.</div>
      );
    }
    return null;
  };

  return (
    <div>
      <div className="mb-4 container-fluid card-controls-card-container">
        <div className="card-image">
          <img style={{ height: 60 }} src={CardIcon} className="popup-icon" alt="" />
        </div>
        <div className="card-info d-flex flex-column justify-content-center">
          <div className="bolder" style={{ paddingBottom: "5px" }}>
            {props.MaskedCardNumber}
          </div>
          <div>{props.CardHoldersName}</div>
        </div>
        <div className="card-toggle-container">
          <div>
            <ButtonGroup
              onClick={() => {
                if (props.CanEdit) {
                  props.showCardControlsModal(
                    true,
                    popupMenuOptions.valid.CardTurnOnOff,
                    props.AgreeNbr,
                    props.CardType,
                    props.IsActive,
                    props.CardNumberLastFour
                  );
                }
              }}
            >
              <ToggleButton
                key="0"
                id={"radio-off-" + props.CardNumberLastFour}
                className="card-toggle-button"
                type="radio"
                variant="outline-danger"
                name="radio"
                value={false}
                checked={!props.IsActive}
                disabled={!props.CanEdit}
              >
                {offText()}
              </ToggleButton>
              <ToggleButton
                key="1"
                id={"radio-on-" + props.CardNumberLastFour}
                className="card-toggle-button"
                type="radio"
                variant="outline-success"
                name="radio"
                value={true}
                checked={props.IsActive}
                disabled={!props.CanEdit}
              >
                {onText()}
              </ToggleButton>
            </ButtonGroup>
          </div>
        </div>
        <div className="card-popup-menu-container">
          <CardControlPopupMenu
            {...props}
            selectCardOption={selectCardOption}
            showPopupMenu={props.cardState.showPopupMenu}
            setProcessStep={props.setProcessStep}
          />
        </div>
        {callUs()}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/card-controls/card/card-controls-card.component.js